import React, { useState, useEffect } from 'react';
import { FaEdit, FaTrash, FaPlus, FaSearch, FaSave, FaTimes } from 'react-icons/fa';
import '../Nucleos/Nucleos.css';

import API_BASE_URL from '../../../../config/api';

const PrazosValidacao = () => {
  const [prazosValidacao, setPrazosValidacao] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [formData, setFormData] = useState({
    descricao: '',
    validade: '',
    ativo: true
  });

  useEffect(() => {
    const fetchPrazos = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/prazos-validacao`);
        if (!response.ok) {
          throw new Error('Erro ao buscar prazos de validação');
        }
        const data = await response.json();
        setPrazosValidacao(data);
      } catch (error) {
        console.error('Erro ao carregar prazos de validação:', error);
      }
    };

    fetchPrazos();
  }, []);

  const filteredPrazosValidacao = prazosValidacao.filter(prazo =>
    prazo.descricao.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      descricao: formData.descricao,
      validade: parseInt(formData.validade, 10),
      ativo: formData.ativo
    };

    try {
      if (editingId) {
        const response = await fetch(`${API_BASE_URL}/prazos-validacao/${editingId}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        });

        if (!response.ok) {
          throw new Error('Erro ao atualizar prazo de validação');
        }

        const updated = await response.json();
        setPrazosValidacao(
          prazosValidacao.map((prazo) =>
            prazo.id === editingId ? updated : prazo
          )
        );
      } else {
        const response = await fetch(`${API_BASE_URL}/prazos-validacao`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        });

        if (!response.ok) {
          throw new Error('Erro ao criar prazo de validação');
        }

        const created = await response.json();
        setPrazosValidacao([...prazosValidacao, created]);
      }

      resetForm();
    } catch (error) {
      console.error('Erro ao salvar prazo de validação:', error);
    }
  };

  const handleEdit = (prazo) => {
    setFormData({
      descricao: prazo.descricao,
      validade: prazo.validade.toString(),
      ativo: prazo.ativo
    });
    setEditingId(prazo.id);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Tem certeza que deseja excluir este prazo de validação?')) {
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/prazos-validacao/${id}`, {
        method: 'DELETE'
      });

      if (!response.ok && response.status !== 204) {
        throw new Error('Erro ao excluir prazo de validação');
      }

      setPrazosValidacao(prazosValidacao.filter((prazo) => prazo.id !== id));
    } catch (error) {
      console.error('Erro ao excluir prazo de validação:', error);
    }
  };

  const resetForm = () => {
    setFormData({ descricao: '', validade: '', ativo: true });
    setEditingId(null);
    setShowForm(false);
  };

  const handleToggleStatus = async (id) => {
    const prazo = prazosValidacao.find((p) => p.id === id);
    if (!prazo) return;

    const updatedPrazo = {
      ...prazo,
      ativo: !prazo.ativo
    };

    try {
      const response = await fetch(`${API_BASE_URL}/prazos-validacao/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          descricao: updatedPrazo.descricao,
          validade: updatedPrazo.validade,
          ativo: updatedPrazo.ativo
        })
      });

      if (!response.ok) {
        throw new Error('Erro ao atualizar status do prazo de validação');
      }

      const saved = await response.json();
      setPrazosValidacao(
        prazosValidacao.map((p) => (p.id === id ? saved : p))
      );
    } catch (error) {
      console.error('Erro ao atualizar status do prazo de validação:', error);
    }
  };

  return (
    <div className="nucleos-container">
      <div className="tabela-header">
        <div className="header-content">
          <h1>Prazos de Validação</h1>
        </div>
        {!showForm && (
          <button 
            className="btn-primary"
            onClick={() => setShowForm(true)}
          >
            <FaPlus /> Novo Prazo
          </button>
        )}
      </div>

      <div className="table-controls">
        <div className="search-container">
          <FaSearch className="search-icon" />
          <input
            type="text"
            placeholder="Pesquisar prazos de validação..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div className="table-info">
          <span>{filteredPrazosValidacao.length} registro(s) encontrado(s)</span>
        </div>
      </div>

      {showForm ? (
        <div className="inline-form">
          <div className="form-header">
            <h2>{editingId ? 'Editar Prazo de Validação' : 'Novo Prazo de Validação'}</h2>
            <button className="btn-close" onClick={resetForm}>
              <FaTimes />
            </button>
          </div>
          
          <form onSubmit={handleSubmit} className="form-content">
            <div className="form-group">
              <label htmlFor="descricao">Descrição *</label>
              <textarea
                id="descricao"
                value={formData.descricao}
                onChange={(e) => setFormData({...formData, descricao: e.target.value})}
                required
                rows={3}
                placeholder="Digite a descrição do prazo"
              />
            </div>

            <div className="form-group">
              <label htmlFor="validade">Validade (dias) *</label>
              <input
                type="number"
                id="validade"
                value={formData.validade}
                onChange={(e) => setFormData({...formData, validade: e.target.value})}
                required
                min="1"
                placeholder="Digite a validade em dias"
              />
            </div>

            <div className="form-group">
              <div className="checkbox-container">
                <input
                  type="checkbox"
                  id="ativo"
                  checked={formData.ativo}
                  onChange={(e) => setFormData({...formData, ativo: e.target.checked})}
                />
                <label htmlFor="ativo">Ativo</label>
              </div>
            </div>

            <div className="form-actions">
              <button type="button" className="btn-secondary" onClick={resetForm}>
                <FaTimes /> Cancelar
              </button>
              <button type="submit" className="btn-primary">
                <FaSave /> {editingId ? 'Atualizar' : 'Salvar'}
              </button>
            </div>
          </form>
        </div>
      ) : (
        <div className="table-container">
          <div className="table-wrapper">
            <table className="data-table nucleos-table">
              <thead>
                <tr>
                  <th className="col-id">ID</th>
                  <th className="col-nome">Descrição</th>
                  <th className="col-prazo">Validade (dias)</th>
                  <th className="col-status">Status</th>
                  <th className="col-acoes">Ações</th>
                </tr>
              </thead>
              <tbody>
                {filteredPrazosValidacao.map(prazo => (
                  <tr key={prazo.id}>
                    <td className="col-id">{prazo.id}</td>
                    <td className="col-nome">{prazo.descricao}</td>
                    <td className="col-prazo">{prazo.validade}</td>
                    <td className="col-status">
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={prazo.ativo}
                          onChange={() => handleToggleStatus(prazo.id)}
                        />
                        <span className="slider round"></span>
                      </label>
                    </td>
                    <td className="col-acoes">
                      <div className="action-buttons">
                        <button 
                          className="btn-edit"
                          onClick={() => handleEdit(prazo)}
                          title="Editar"
                        >
                          <FaEdit />
                        </button>
                        <button 
                          className="btn-delete"
                          onClick={() => handleDelete(prazo.id)}
                          title="Excluir"
                        >
                          <FaTrash />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            
            {filteredPrazosValidacao.length === 0 && (
              <div className="empty-state">
                <div className="empty-state-icon">
                  <FaSearch size={32} />
                </div>
                <h3>Nenhum prazo de validação encontrado</h3>
                <p>Tente ajustar os filtros de pesquisa ou cadastre um novo prazo.</p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default PrazosValidacao;
